import { apiFetch } from '@/lib/api';

export interface ApiKeyRow {
  id: string;
  name: string;
  /** The first characters of the key, to tell keys apart. */
  prefix: string;
  created_at: string;
  last_used_at: string | null;
  revoked_at: string | null;
}

export interface ApiKeyList {
  keys: ApiKeyRow[];
  max_active: number;
}

/** A newly created key. `key` is shown once; only its hash is stored. */
export interface ApiKeyCreated extends ApiKeyRow {
  key: string;
}

export function fetchApiKeys(): Promise<ApiKeyList> {
  return apiFetch<ApiKeyList>('/api/v1/api-keys');
}

export function createApiKey(name: string): Promise<ApiKeyCreated> {
  return apiFetch<ApiKeyCreated>('/api/v1/api-keys', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export async function revokeApiKey(id: string): Promise<void> {
  await apiFetch<unknown>(`/api/v1/api-keys/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
